export default "__VITE_ASSET__CBVWEPTu__"